import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import {fetchArticlesDispatch} from '../actions';
import {fetchEventsDispatch} from '../actions';
import {fetchBooksDispatch} from '../actions';

class IsdaSidebar extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			ready: false
		};
	}

	loadData() {
		this.setState( {
			               ready: true
		               } );
	}

	componentWillMount() {
		this.loadData();
		this.props.fetchArticlesDispatch();
		this.props.fetchEventsDispatch();
		this.props.fetchBooksDispatch();
	}

	renderArticles( articles )  {
		return articles.map( ( article, ind ) => {
			return (
				<li key={ ind }>
					<a href={ article.guid } className="widget-articles-link">
						{ article.post_title }
					</a>
				</li>
			);
		} );
	}

	renderEvents( events )  {
		return events.map( ( event, ind ) => {
			return (
				<li key={ ind }>
					<a href={ event.link } className="widget-events-link">
						<span className="event-date">
							{event.day}
							<span className="event-month">{ event.month }</span>
						</span>
						{ event.title }
					</a>
				</li>
			);
		} );
	}

	renderBooks( books )  {
		return books.map( ( book, ind ) => {
			return (
				<li key={ ind }>
					<a href={ book.link } className="widget-articles-link">
						{ book.title }
					</a>
				</li>
			);
		} );
	}

	render() {
		return(<Fragment>
			<h2 id="showcase-right-title">New on
				<a
				href="https://www.isda.org/"><img
				src={ ISDA_Membership.sidebar_isda_logo }
				alt="ISDA" /></a>
			</h2>
			<div className="showcase-widget">
				<h3 className="showcase-widget-title">Articles</h3>
				<ul>
					{this.renderArticles( this.props.articles )}
				</ul>
			</div>
			<div className="showcase-widget">
				<h3 className="showcase-widget-title">Events</h3>
				<ul>
					{this.renderEvents( this.props.events )}
				</ul>
			</div>
			<div className="showcase-widget">
				<h3 className="showcase-widget-title">Books</h3>
				<ul>
					{this.renderBooks( this.props.books)}
				</ul>
			</div>
		</Fragment>
		);
	}
}

function mapStateToProps( { articles, events, books } ) {
	return { articles, events, books };
}

export default connect( mapStateToProps, { fetchArticlesDispatch, fetchEventsDispatch, fetchBooksDispatch } )( IsdaSidebar );